var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoico({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.689,
    viewBox: "0 0 22 19.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45",
    transform: "translate(-1.998 -5.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    d: "M22.083,9.172A9.89,9.89,0,0,0,4.565,12.607L3.381,10.338a.734.734,0,0,0-1.3.685l2.28,4.322a.733.733,0,0,0,.81.367,1.555,1.555,0,0,0,.183-.066L9.7,13.373a.74.74,0,0,0-.7-1.3L5.84,13.736a8.395,8.395,0,1,1,3.332,8.028.733.733,0,1,0-.869,1.18,9.758,9.758,0,0,0,5.832,1.913A9.887,9.887,0,0,0,22.083,9.172Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoico);
export default __webpack_public_path__ + "static/media/undoico.ce7e4b187b06a87850885572952c60f5.svg";
export { ForwardRef as ReactComponent };